import { ContentObjectDetail } from '../content-object-detail';
import { usePollQuery } from '../queries';

type P = {
  postId: string;
};

const PollDetail = ({ postId }: P) => {
  const { data: contentObject, isLoading } = usePollQuery(postId);

  return <ContentObjectDetail contentObject={contentObject} isLoading={isLoading} />;
};

export default PollDetail;
